var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgImgBackgroundLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 929.915,
    height: 568.903,
    viewBox: "0 0 929.915 568.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 42,
    width: 929.915,
    height: 568.903,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.6,
    y1: 0.5,
    x2: 6.799,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3db3ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215c58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.88,
    y1: 0.5,
    x2: 13.444,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215c58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.258,
    y1: 0.5,
    x2: 3.301,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2.231,
    y1: 0.5,
    x2: 8.777,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.617,
    y1: 0.5,
    x2: 25.335,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.314,
    y1: 0.5,
    x2: 53.098,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1396.318,
    y1: 0.5,
    x2: 6604.074,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1.088,
    y1: 0.5,
    x2: 43.155,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2.284,
    y1: 0.5,
    x2: 79.981,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -4.106,
    y1: 0.5,
    x2: 120.567,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -3678.078,
    y1: 0.491,
    x2: 5023.082,
    y2: 0.491,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -8.653,
    y1: 0.5,
    x2: 209.013,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -4.815,
    y1: 0.5,
    x2: 234.728,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -2.774,
    y1: 0.5,
    x2: 139.851,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -2.869,
    y1: 0.5,
    x2: 118.13,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -5.378,
    y1: 0.5,
    x2: 158.318,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.269,
    y1: 0.5,
    x2: 4.919,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1.313,
    y1: 0.5,
    x2: 7.121,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1.573,
    y1: 0.5,
    x2: 12.526,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#748f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215c58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -6.468,
    y1: 0.5,
    x2: 18.209,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -10.401,
    y1: 0.5,
    x2: 113.17,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -2.771,
    y1: 0.5,
    x2: 42.604,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1.601,
    y1: 0.5,
    x2: 22.15,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -5.909,
    y1: 0.5,
    x2: 1.874,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3f893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c724e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -3.685,
    y1: 0.5,
    x2: 3.966,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -4.957,
    y1: 0.5,
    x2: 1.982,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -2.007,
    y1: 0.5,
    x2: 1.737,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -3.857,
    y1: 0.5,
    x2: 3.938,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2.666,
    y1: 0.5,
    x2: 2.893,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -10.011,
    y1: 0.5,
    x2: 5.09,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -13.156,
    y1: 0.5,
    x2: 8.046,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -3903.401,
    y1: 0.508,
    x2: 3903.422,
    y2: 0.508,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -14.704,
    y1: 0.5,
    x2: 10.741,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -19.226,
    y1: 0.5,
    x2: 15.796,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -34.429,
    y1: 0.5,
    x2: 30.688,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -3911.283,
    y1: 0.51,
    x2: 3911.317,
    y2: 0.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -6.808,
    y1: 0.5,
    x2: 3.816,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -8.323,
    y1: 0.5,
    x2: 5.503,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -11.818,
    y1: 0.5,
    x2: 8.836,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -20.772,
    y1: 0.5,
    x2: 17.277,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -13.695,
    y1: 0.5,
    x2: 27.988,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -9.804,
    y1: 0.5,
    x2: 19.201,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -6.935,
    y1: 0.5,
    x2: 16.031,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -7.685,
    y1: 0.5,
    x2: 17.829,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -5033.978,
    y1: 0.492,
    x2: 2968.929,
    y2: 0.492,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -9.827,
    y1: 0.5,
    x2: 22.416,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -18.069,
    y1: 0.5,
    x2: 39.328,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -6.861,
    y1: 0.5,
    x2: 12.602,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -7.466,
    y1: 0.5,
    x2: 14.079,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -10.255,
    y1: 0.5,
    x2: 19.472,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -19.629,
    y1: 0.5,
    x2: 37.651,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -5.936,
    y1: 0.5,
    x2: 4.259,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -4.182,
    y1: 0.5,
    x2: 1.391,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -1.664,
    y1: 0.5,
    x2: 3.468,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -5.32,
    y1: 0.5,
    x2: 8.285,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -1.918,
    y1: 0.5,
    x2: 2.986,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -3.509,
    y1: 0.5,
    x2: 2.302,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -5.918,
    y1: 0.5,
    x2: 7.433,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -2.971,
    y1: 0.5,
    x2: 6.181,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -22.489,
    y1: 0.5,
    x2: 25.56,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -27.624,
    y1: 0.5,
    x2: 9.548,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -5.017,
    y1: 0.5,
    x2: 9.625,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -15.132,
    y1: 0.5,
    x2: 2.157,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#769141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -9.241,
    y1: 0.5,
    x2: 1.913,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#899b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c724e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -19.339,
    y1: 0.5,
    x2: 1.55,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -10.662,
    y1: 0.5,
    x2: 1.183,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d8247"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -13.933,
    y1: 0.5,
    x2: 1.128,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -1786.415,
    y1: 0.5,
    x2: 10.054,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -61.327,
    y1: 0.5,
    x2: 1.066,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -39.315,
    y1: 0.5,
    x2: 2.768,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -35.236,
    y1: 0.5,
    x2: 2.348,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Scorri_gruppo_35",
    "data-name": "Scorri gruppo 35",
    transform: "translate(0 -42)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4913",
    "data-name": "Raggruppa 4913",
    transform: "translate(-135.859 -591.728)",
    opacity: 0.151
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_22",
    "data-name": "Raggruppa 22",
    transform: "translate(135.859 591.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_75",
    "data-name": "Tracciato 75",
    d: "M367.135,1018.608c-.549,12.633-5.569,42.7-39.955,49.242,16.444-48.98,10.316-109.915-16.78-167.254,14.549,35.173,35.006,103.781,8.593,167.56-24.62.354-52.6-23.5-61.035-52.038-9.285-31.406.9-49.88,21.261-82.427C298.155,903.417,300,891.569,295.7,873.384c46.98,40.835,73.217,105.908,71.434,145.225",
    transform: "translate(-92.525 -488.853)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_76",
    "data-name": "Tracciato 76",
    d: "M205.35,797.132c-20.591,35.129-36.68,39.094-39.752,22.641-3.275-17.432,7.69-53.347,12.984-70.6,4.276-14.055,5.036-17.584,4.215-19.863-.257-.105-.584-.225-.861-.337,7.551-9.2,33.327-37.312,47.574-13.034,4.561,10.5-.737,32.455-15.714,65.279.755-43.356-6.772-62.189-22.95-57.533,10.447-1.287,14.794,9.292,16.58,18.354,3.447,17.571,5.912,41.408-2.074,55.093",
    transform: "translate(-125.215 -549.882)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_77",
    "data-name": "Tracciato 77",
    d: "M259.051,966.829a.1.1,0,0,0-.022-.055.1.1,0,0,1,.022.055.1.1,0,0,0-.022-.055.1.1,0,0,1,.022.055M438.617,1196.7c.023.005.081-.008.1,0-.023-.007-.081.007-.1,0m0,0,.09-.053a.428.428,0,0,0-.172-.014c-20.512-9.667-34.176-30.049-56.943-36.177-14.59-3.909-37.793-6.008-62.388-8.23-20.723-1.89-20.723-1.89-21.991-2.473l-.388-.536c42.074.352,75.288.639,97.875-17.358,4.983-3.987,9.863-13.685,4.791-37.426-1.125-5.458-4.676-22.087-1.614-25.727l-.127.049.042-.2-.218.158c-26.184,4.317-51.287-23.116-78.012-2.673-8.372,6.42-24.262,41.471-24.046,72.588.023,2.586,1.12,6.567-.479,8.551l-.815-.55c-1.533-4.482-1.084-11.371,3.262-49.014,3.344-28.937,4.464-46.206,1.158-60.3-6.312-27.046-30.068-44.166-39.348-69.524a5.171,5.171,0,0,1-.16-1.021l-.042.194-.04-.135c-.014.048,0,.077-.007.126l-.1-.224c0,.1.005.2.012.306-2.122,5.588-8.777,10.173-14.152,13.846-12.779,8.83-17.389,23.5-13.617,43.644,2.427,12.9,11.91,38.578,20.781,56.1,11.538,22.885,28.789,42.245,40.424,65.1a1.9,1.9,0,0,0-.375.35l-1.461-1.455c-28.059-39.4-40.664-62.115-61.585-99.728-9.211-16.535-17.888-32.149-30.875-43.124-7.685-6.467-19.5-6.411-25.357-15.821a.842.842,0,0,0,.005.2l.072.141c5.173,16.6,6.18,34.2,12.043,50.649a160.018,160.018,0,0,0,17.67,32.889c28.457,39.666,72.865,66.965,87.425,75.93a6.838,6.838,0,0,1,1.786,1.951l.023,0c-25.7-14.223-46.432-36.107-73.737-47.923-6.327-2.7-6.327-2.7-4.026,14.313-.206.156-.254.121-.272.091l.078.1c.025.03.048.031.038.059,24.741,29.122,29.9,35.2,40.037,39.712,13.991,6.207,25.433-10,39.327-4.367l-.117.3c-22.092,9.175-22.092,9.175-.613,39.516l.3-.083c11.658,2.341,11.658,2.341,13.127,1.186.244-14.622-12.952-25.338-11.834-40.25a6.826,6.826,0,0,0,1.586,1l.224.127.95-.072.507.59c25.753,41.384,26.569,41.839,70.674,65.606l-.579-.708c-13.6-21.96-13.6-21.96-17.83-25.583-16.719-14.335-36.624-24.452-52.3-40.11l-.012-.278c31.129,15.905,56.48,41.691,90.472,52.676,23.712,7.7,33.241,1.559,37.33-1.1,4.3-2.766,8.343-5.383,13.453-5.824l.071.015",
    transform: "translate(-122.391 -454.757)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_78",
    "data-name": "Tracciato 78",
    d: "M348.477,1196.375c-10.339-2.759-62.978-39.629-85.534-93.761.186-.008.419-.037.623-.045,22.386,50.91,69.789,83.3,85.387,93.936-.145-.029-.311-.094-.475-.13",
    transform: "translate(-89.441 -405.143)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_79",
    "data-name": "Tracciato 79",
    d: "M173.285,831.971c-25.81,33.774-36.866,73.744-33.794,122.2-.048-.34-.1-.805-.152-1.171-2.964-50.966,7.933-92.311,34.314-130.112a34.737,34.737,0,0,1,1.694,6.439c-.621.777-1.435,1.84-2.063,2.642",
    transform: "translate(-134.76 -507.295)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_80",
    "data-name": "Tracciato 80",
    d: "M154.21,993.989c1.337,4.919,2,7.112,2.309,8.039-3.622-13.206-8.693-30.747-11.647-44.137l-3.57-18.636a155.091,155.091,0,0,1-2.186-20.357c6.058,39.109,7.121,46.143,15.094,75.092",
    transform: "translate(-134.669 -472.229)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_15",
    "data-name": "Raggruppa 15",
    transform: "translate(4.872 431.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_81",
    "data-name": "Tracciato 81",
    d: "M155.095,981.152h0l.033.082-.033-.082",
    transform: "translate(-133.705 -881.404)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_82",
    "data-name": "Tracciato 82",
    d: "M157.3,987.52c.21,1.132.407,2.236.588,3.39.229,1.517.483,3.04.655,4.569-.033-.209-.068-.519-.12-.732a95.6,95.6,0,0,0,2.363,12.981l.029.109a.112.112,0,0,1,.008.053l-.064-.168-.374-.965c-21.856-49.124-21.032-98.439-20.932-98.668,5.473,26.584,13.038,52.708,17.847,79.43",
    transform: "translate(-139.427 -908.09)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_83",
    "data-name": "Tracciato 83",
    d: "M153.1,962.98,153.1,963l.031.083-.026-.108m-.314-16.943c-.031-.564-.078-1.182-.078-1.764-1.018-17.2-10.825-61.924-10.9-62.244-.067.542-1.98,58.046,8.335,75.1.016.029.044.034.059.063.027.005.022.03.015.053l.041.06a.165.165,0,0,0,.034.059.054.054,0,0,1,.038.06.166.166,0,0,1,.031.082.088.088,0,0,0,.044.034.5.5,0,0,0,.04.059,32.073,32.073,0,0,1,2.639,5.327l.014.078c.019.027.044.034.038.06l-.026-.109-.143-.99a82.151,82.151,0,0,1-.165-10.941c0,.228,0,.43.014.636.046-3.155,0-4.582-.026-5.623",
    transform: "translate(-133.752 -485.695)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_84",
    "data-name": "Tracciato 84",
    d: "M152.705,912.028c-.063.9-.135,1.818-.25,2.7a2.559,2.559,0,0,0,.008-.4,59.682,59.682,0,0,0-.647,8.869l.029.107-.01.048-.014-.079-.187-.52c-1.027-2.169-2.892-3.838-3.72-6.116a41.176,41.176,0,0,1-2.023-9.823c-1.488-14.693-.117-37.45.188-40.039l.029-.019c.292,1.125,7.284,28.291,6.657,43.844l-.048,1.027a1.866,1.866,0,0,1-.012.4",
    transform: "translate(-132.443 -491.273)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_16",
    "data-name": "Raggruppa 16",
    transform: "translate(19.226 358.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_85",
    "data-name": "Tracciato 85",
    d: "M152.1,876.361a.071.071,0,0,1-.01-.052.071.071,0,0,0,.01.052",
    transform: "translate(-149.155 -846.712)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_86",
    "data-name": "Tracciato 86",
    d: "M153.869,878.572c-.075.337-.147.674-.224,1.038.016-.071.031-.145.04-.193a31.816,31.816,0,0,0-.8,4.81l-.086-.22c-.554-1.158-1.588-2.014-2.057-3.227a19.187,19.187,0,0,1-.744-4.411c-.3-5.861.793-21.157,1.275-21.739,2.9,13.759,3.087,16.783,3.008,18.638-.007,1.114-.067,2.213-.149,3.285-.038.674-.164,1.356-.258,2.019",
    transform: "translate(-149.941 -854.63)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_87",
    "data-name": "Tracciato 87",
    d: "M139.173,904.073c-.325,12.175-.474,18.85,1.092,31.053l-1.939-15.751-2.015-25.586c.269,3.424,1.872,6.453,2.791,9.662a2.1,2.1,0,0,1,.071.623",
    transform: "translate(-135.693 -481.4)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_88",
    "data-name": "Tracciato 88",
    d: "M142.486,885.144c.03-.247.03-.247-.507-2.463-2-8.073-3.1-14.814-3.637-18.069-.7-4.273-.807-4.828-1.05-5.462-.266.171-.472.329-.782,3.526l-.1.938c-.075,1.048-.152,2.094-.2,3.146a2.835,2.835,0,0,1,.038-.421c-.086,1.323-.265,4.851-.337,8.706l-.023.805-.007.048c-.112,12.956.259,21.664.946,22.722.73-.244,5.637-13.355,5.662-13.476",
    transform: "translate(-135.859 -494.052)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_89",
    "data-name": "Tracciato 89",
    d: "M146.637,866.366c.1-.257-3.26-22.061-3.636-23.836-.173-.6-.6-2.358-1.517-.937-.1.183-.227.434-.337.613l-.169.418c-.2.59-.374,1.159-.556,1.753a.46.46,0,0,0,.067-.188c-1.241,4.59-1.241,4.59-1.408,4.782l-.025-.03.005.1,0,.479c-.389,17.149-.374,17.176.4,18.888.446.956.937,1.39,2.367.991,1.91-.524,3.136-2.131,4.807-3.036",
    transform: "translate(-134.779 -500.662)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_90",
    "data-name": "Tracciato 90",
    d: "M150.657,849.5c-3.439,1.99-4.546,1.27-4.874.669-.782-1.409-.633-5.045-.583-6.428a33.452,33.452,0,0,0,.041-3.962c.005-.026.011-.049.016-.074l.083-.033a12.872,12.872,0,0,0,1.165-2.456c-.014.049-.015.072-.049.09.524-1.125.785-1.4.917-1.444.067-.063.067-.063.754-.168.145.132.206.2.478.811.448,1.44,2.554,11.508,2.314,12.848a.792.792,0,0,1-.262.146",
    transform: "translate(-132.463 -502.619)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_91",
    "data-name": "Tracciato 91",
    d: "M340.768,855.876h0l-.027-.005h0l-.048-.011h0c-10.261-1.328-24.037,6.931-31.328,53.94a140.162,140.162,0,0,1-22.428,56.921c-21.232,31.524-23.626,31.716-85.665,36.619,4.838,4.183,11.259,9.741,16.1,13.924-42.177-12.192-42.246,2.318-42.317,17.635-10.717-75.411,12.254-164,75.872-179.641-18.906.98-80.832,14.129-84.142,142.711-14.281-54.016-10.571-105.29,11-152.477-.5,4.549-1.148,10.607-1.649,15.128,20.776-53.458,56.639-69.678,106.573-48.147,12.8,6.228,42.746,20.791,58.061,43.4h0",
    transform: "translate(-127.672 -514.469)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_92",
    "data-name": "Tracciato 92",
    d: "M164.922,813.266c4.193-8.987.908-18.63,2.543-27.839.961-5.411,5.013-9.622,5.978-15.03a10.957,10.957,0,0,0,.031-4.373c-.737-2.434-5.484-1.537-4.807-4.58,2.4-10.514,9.813-18.856,12.518-29.279a6.163,6.163,0,0,0-.037-2.031c-1.977,1.27-8.551,10.425-27.588,68.106l.115-.382c1.242-2.717,1.9-3.079,4.044-.34-3.729-.982-3.729-.982-7.865,14.066-3.282,14.827-7.719,34.591-10.2,49.593l-.212,1.674a22.818,22.818,0,0,0,.13,7.393c.58-.837,1.955-2.741,3.752-19.156,1.125-10.257,2.509-17.5,4.115-21.53,3.817,3.178.345,8.148,2.872,11.653,1.155-.18,2.86-.447,4.759-13.952,1.268-9.265,2.434-10.455,3.627-10.932,1.712,1.305,1.712,1.305,2.8,1.565,1.429-.982,1.894-1.262,3.427-4.624",
    transform: "translate(-134.632 -541.175)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_93",
    "data-name": "Tracciato 93",
    d: "M312.1,1177.024a3.6,3.6,0,0,0-.375.1l-.49-.16a4.689,4.689,0,0,0,.866.061h0m5.355.3.005-.026-.026-.005c-29.222-20.045-54.483-45.107-83.582-65.257a14.267,14.267,0,0,0-3.554-1.577c-.193,3.832,34.75,36.3,61.541,56l.064.064c2.93,2.124,5.075,3.576,7.6,5.207,5.831,3.588,8.683,4.911,11.753,5.447-2.908-.12-6.433-1.49-15.752-8.028,13.9,9.247,32.67,21.2,47.044,29.612l-.465-.276c-7.032-4.25-14.9-9.771-24.633-21.159",
    transform: "translate(-101.363 -402.262)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_94",
    "data-name": "Tracciato 94",
    d: "M260.421,769.335c-23.414,41.883-53.011,48.172-59.873,23.714-1.472-5.047-1.472-5.047,5.192-13.983a114.14,114.14,0,0,1,21.86-22.28c18.166-13.487,28.935-11.315,33.739-8.835.43.245.96.586,1.394.831a16.294,16.294,0,0,1,4.175,3.864c-13.943,3.618-20.32,5.252-34.464,16.293,9.262-.707,18.825-2.945,32.006-7.386-.868,1.786-2.179,4.488-4.029,7.781",
    transform: "translate(-112.52 -535.343)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_95",
    "data-name": "Tracciato 95",
    d: "M336.675,1185.435c5.933,4.5,5.862,5.293,5.817,5.637-.913.688-18.4-9.259-25.829-14.457-6.849-4.818-11.09-9-12.53-12.394h0c6.348,3.414,24.246,14.971,32.542,21.213",
    transform: "translate(-74.396 -382.624)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_17",
    "data-name": "Raggruppa 17",
    transform: "translate(39.409 557.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_96",
    "data-name": "Tracciato 96",
    d: "M181.568,1046.152c2.808,5.712,5.241,9.8,6.836,12.4l-7.663-12.91c.012.049.108.2.724.255a1.558,1.558,0,0,0,.1.254",
    transform: "translate(-158.874 -983.441)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_97",
    "data-name": "Tracciato 97",
    d: "M168.929,1000.375a244.309,244.309,0,0,0,4.974,24.681c-.934.811-2.164,1.229-3.088,2.115a10.373,10.373,0,0,0,1.625,3.491c.754-.445,1.786-1.009,2.538-1.451,1.2,4.508,3.435,8.709,4.068,13.378.023.031.108.805-2.011.905.04.058.881,4.923,3.3,3.193,3.008,3.535,3.42,8.2,5.249,12.263-.247.078-.707.232-.982-.156l-12.212-23.336c-11.056-22.88-8.216-30.516-3.522-35.376.025.109.03.187.057.293",
    transform: "translate(-164.724 -1000.082)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_98",
    "data-name": "Tracciato 98",
    d: "M190.991,1054.06c16.986,43.7,16.986,43.7,18,45.2l-11.5-17.029-1.939-3.006c-1.305-2.149-2.826-4.58-5.086-8.764,2.73,4.337,6.365,10.13,9.072,14.459.362.561.73,1.095,1.118,1.611-.242-.633-.242-.633-12.055-19.609-1.66-3.342-3.133-6.495-5.386-11.889,2.58,4.478,6.022,10.433,8.627,14.893a7.815,7.815,0,0,0,.973,1.349c.108-.486.108-.486-11.184-20.152-2.057-5.375-3.561-10.106-4.481-13.135,2.471,4.608,5.737,10.725,8.234,15.337a4.111,4.111,0,0,0,1.226,1.582c.061-.771.061-.771-10.637-21.047a243.609,243.609,0,0,1-6.841-31.967c3.748,8.073,13,29.375,21.863,52.162",
    transform: "translate(-163.115 -999.419)",
    fill: "url(#linear-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_99",
    "data-name": "Tracciato 99",
    d: "M762.806,822.589c4.12,9.19,16.144,41.467-1.975,71.181-7.52-75.482-51.587-116.445-87.242-137.526,35.714,23.269,78.985,66.97,82.544,143.218-15.977,16.563-40.175,12.734-57.526-9.1-15.477-19.484-17.721-41.651-20.649-69.713C673.185,774.4,667.2,758.739,648.9,744.487c45.86,1.955,94.837,35.526,113.907,78.1",
    transform: "translate(51.53 -535.933)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_100",
    "data-name": "Tracciato 100",
    d: "M580.07,995.041c2.1,46.859-43.011,55.061-72.855,60.511-32.468,5.9-39.889,11.329-45.68,24.754-17.066-49.735,9.6-125.2,60.279-134.223,13.5-1.26,22.047.532,33.783,7.14-46.984,18.272-81.961,57.2-91.272,101.648,16.154-54.91,60.823-86.259,97.262-97.295.468.406,1.076.889,1.545,1.3,4.8,4.833,16.025,16.136,16.939,36.17",
    transform: "translate(-18.787 -462.437)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_101",
    "data-name": "Tracciato 101",
    d: "M753.384,946.294c5.733,41.419-20.947,64.781-22.093,65.749-18.091,15.478-30.923,14.227-58.041,2.806-22.94-9.633-39.534-16.605-55.495-1.958,8.284-25.489,29.786-72.237,80.812-98.8,16.043-7.265,38.181-9.142,52.5,23.074-18.141-3.029-65.733-3.99-115.739,52.568,37-38.014,80.98-54.909,117.689-45.165.164.745.3,1.2.365,1.724",
    transform: "translate(40.155 -475.597)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_102",
    "data-name": "Tracciato 102",
    d: "M639.159,1069.856c-.011-.053,0-.1-.026-.108.026.007.015.055.026.108m60.107-292.73.152-.145-.15-.007.055-.116-.134.147c-19.55,3.372-35.387-20.921-56.3-7.6-8.571,5.462-14.672,15.329-29.838,44.216-28.5,54.194-29.955,55.2-31.117,56.008-.18-.116-.456-.251-.651-.368l-.03-.007.254-1.641c24.711-44.614,29.726-72.4,29.545-87.85-.234-21.707-14-37.838-18.507-43.112-2.908-3.41-11.805-13.782-12.6-17.344l-.047.067.018-.072-.031.143c-3.92,7.987-12.574,12.189-16.245,20.405-1.924,4.341-4.107,11.992-3.446,23.724,1.006,17.373,11.966,68.343,17.251,92.84.785,3.737,2.49,8.761,2.127,12.554a3.677,3.677,0,0,0-.452.207l-.333-.68c-10.346-45.4-19.3-61.02-20.3-62.68-6.912-11.461-20.471-13.375-30.193-20.836l-.093-.173a.178.178,0,0,1,.022.131l.307,1.18c1.256,33.189,1.256,33.189,5.1,39.637,11.063,18.607,33.412,25.735,44.757,44.1l-1.013,1.275-.012.2-.158.244.173,1.885-.6-.005c-22.234-5.888-46.865-12.039-57.963-10.107-13.906,2.414-14.836,17.849-24.6,24.42l-.1.079a.284.284,0,0,0,.161-.015l.963.333c25.136,17.75,25.136,17.75,31.756,16.648,20.835-3.449,31.855-23.335,50.637-30.262l.345.4-.874,1.786c-57.941,50.166-67.275,59.413-76.746,75.889-3.885,6.751-7.647,18.9-3.657,38.505,1.206,6,3.754,18.473,1.694,22.607l.123-.077-.034.149.1-.235c4.84-2.75,12.112-3.711,17.84-4.246,12.514-1.12,28.023-2.527,41.893-26.076,5.913-10.059,17.608-50.3,19.822-94.68.191-3.679-.3-8.792,1.166-12.171l.568.071c.6,1.824.8,2.524-.737,33.293-3.088,60.717-4.949,97.357,3.169,116.594,10.646,25.147,40.435,24.972,56.568,42.827.248.382.255.462.259.561l.139.056-.111-.3c1.137-6.918,7.615-17.107,13.323-26.1,14.835-23.339,14.137-40.037,7.953-60.982-.269-.971-7.917-25.342-68.926-94.683-2.929-3.339-7.7-7.379-9.328-11.553.16-.268.339-.633.5-.9a21.507,21.507,0,0,1,3.324,1.956c30.412,29.54,48.174,71.86,90.548,89.255,23.151,9.5,36.3,3.408,51.2-10.276,10-9.178,16.427-13.737,19.185-13.5l-.135-.078.1.021.056-.04-.065-.038-.072-.015.143-.1-.2-.1c-18.267-17.6-12.27-50.67-39.8-62.359-11.706-4.957-15.234-6.452-41.607-7.921-5.329-.288-12.463-.157-17.8-.071-21.343.278-42.495,9.325-63.985,1.144-.13-.33-.265-.766-.4-1.1,2.5-1.383,6.639-.743,9.464-.715,42.642.347,83.11-8.148,98.444-20.7,8.115-6.647,16.733-20.3,11.375-47.542-1.39-7.031-4.6-23.462-3.191-25.99",
    transform: "translate(-5.004 -545.13)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_103",
    "data-name": "Tracciato 103",
    d: "M586.949,842.4c-35.476-20.282-76.331-31.225-121.457-32.489a73.032,73.032,0,0,1,4.445-10.25c40.59,5.117,79.953,19.105,116.935,41.536.055.366.049.846.076,1.2",
    transform: "translate(-15.459 -515.782)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_104",
    "data-name": "Tracciato 104",
    d: "M625.193,1058.716a393.036,393.036,0,0,1-164.39,79.819,29.068,29.068,0,0,1-5.862-6.35c65.546-11.432,122.844-36.463,170.315-74.466l-.063,1",
    transform: "translate(-19.313 -421.524)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_105",
    "data-name": "Tracciato 105",
    d: "M644.8,1021.408c.365,27.71-47.684,51.5-62.421,58.108a1.443,1.443,0,0,1-.274-.36c.385-2.247,12.91-43.747,20.628-58.173,2.707-5.031,7.229-13.419,20.057-17.533a31.753,31.753,0,0,1,5.292-1.084,5.03,5.03,0,0,1-.782.236c8.466-.78,11.981-1.132,15.188-3.2l.048-.092a.261.261,0,0,1,.005.076c.029-.018.052-.014.059-.04l-.038.169-.225,1.192c-.1,6.989,2.38,13.7,2.464,20.7",
    transform: "translate(27.133 -442.857)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_106",
    "data-name": "Tracciato 106",
    d: "M597.3,1029.429c-1.042,19-26.561,58.231-28.95,60.855-1.148-.655-13.186-31.059-15.483-52.632-.9-8.47,1.373-15.618,7.394-23.126l1.272-1.447a55.451,55.451,0,0,1,4.381-3.886c-.16.167-.4.421-.565.636,7.4-5.687,10.77-8.3,12.34-11.453l.056-.141.072-.087-.048.22.438,1c4.87,6.163,11.885,10.233,16.155,16.948a27.893,27.893,0,0,1,2.937,13.108",
    transform: "translate(16.385 -443.282)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_18",
    "data-name": "Raggruppa 18",
    transform: "translate(528.699 601.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_107",
    "data-name": "Tracciato 107",
    d: "M537.18,1032c-.023-.03-.023-.03-.018-.055-.005.025-.005.025.018.055",
    transform: "translate(-517.982 -1031.949)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_108",
    "data-name": "Tracciato 108",
    d: "M560.323,1055.452c.127,14.3-19.378,46.522-20.312,47.56-1.027-.524-13-22.516-16.47-39.734-1.637-8.125,1.723-13.875,4.893-18l.98-1.154a40.5,40.5,0,0,1,3.47-3.176c-.134.149-.345.331-.475.455,4.795-3.671,8.581-6.574,9.835-9.338l.048-.117c-.006.025-.006.025.018.055-.007.025-.008.049.011.052l.418.774c4.374,4.69,10.4,7.51,14.394,12.672a20.317,20.317,0,0,1,3.19,9.95",
    transform: "translate(-523.112 -1031.949)",
    fill: "url(#linear-gradient-33)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_109",
    "data-name": "Tracciato 109",
    d: "M530.09,1074.907c-.477,10.293-11.2,30.926-11.677,31.458-.541-.169-10.953-14.66-14.739-26.786-1.686-5.427.463-9.515,2.52-12.491l.664-.717a14.282,14.282,0,0,1,2.366-2.271c-.127.073-.218.179-.336.257,3.958-3.219,5.737-4.683,6.658-6.585a.027.027,0,0,0-.022-.03c.036-.019.055-.015.059-.037.025.027.025.027.016.053l.33.575c3.492,3.033,8.143,4.468,11.236,8.071a13.073,13.073,0,0,1,2.924,8.5",
    transform: "translate(-1.735 -421.529)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_110",
    "data-name": "Tracciato 110",
    d: "M503.572,1090.367c.065-5.481-5.472-5.741-8.121-8.688l-.164.292c-.868,1.1-.968,1.187-3.285,3.036a1.254,1.254,0,0,1,.112-.179,7.284,7.284,0,0,0-2.163,2.494,26.467,26.467,0,0,0-.915,2.612c-.165,4.417,5.315,12.206,8.542,16.446a2.088,2.088,0,0,0,.39-.046c3.357-6.485,5.542-12.769,5.6-15.967",
    transform: "translate(-6.861 -412.772)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_19",
    "data-name": "Raggruppa 19",
    transform: "translate(588.316 627.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_111",
    "data-name": "Tracciato 111",
    d: "M632.023,1062.05a.025.025,0,0,1,.031-.019.025.025,0,0,0-.031.019",
    transform: "translate(-542.95 -1047.19)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_112",
    "data-name": "Tracciato 112",
    d: "M655.853,1066.021a.063.063,0,0,1-.055.014l-.942.633c-3.255,2.889-3.255,2.889-10.32,11.457.193-.186.446-.432.668-.612a46.979,46.979,0,0,1-5.368,5.394c-22.592,19.694-72.579-3.219-73.056-3.495.373-.657,38.971-21.447,57.88-27.234,14.72-3.858,21.363,4.306,23.538,7,2.617,3.225,4.7,5.794,7.589,6.8a.189.189,0,0,1,.112-.027l-.047.067",
    transform: "translate(-566.78 -1051.161)",
    fill: "url(#linear-gradient-37)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_113",
    "data-name": "Tracciato 113",
    d: "M608.328,1102.156a.947.947,0,0,1-.127.022l-.845.145c-3.136,1.4-3.136,1.4-10.56,6.146a5.9,5.9,0,0,1,.61-.246,34.793,34.793,0,0,1-5.48,2.765l-1.528.629c-21.294,6.971-50.255-21.572-50.539-21.865a2.679,2.679,0,0,0,0-.38c.4-.112.6-.172,8.245-1.509,18.124-3.069,37.682-6.009,45.6-4.145,8.473,2.006,10.317,8.348,11.121,11.076.866,3.044,1.734,5.914,3.445,7.271l.063.04a.409.409,0,0,1-.01.049",
    transform: "translate(11.703 -412.24)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_114",
    "data-name": "Tracciato 114",
    d: "M564.967,1118.018A.025.025,0,0,0,565,1118a.025.025,0,0,1-.029.019l-.688.026c-2.538.516-2.538.516-8.168,2.792a1.26,1.26,0,0,0,.434-.136,22.84,22.84,0,0,1-4.118,1.237l-1.268.262c-7.061.85-10.562-1.573-13.116-3.365-7.966-5.537-18.581-17.875-18.865-18.9l.176-.118c29.988-.05,35.726,2.223,37.875,3.068,3.89,1.547,6.011,4.716,6.362,9.422.134,1.973.313,4.414,1.369,5.63l.057.067a.086.086,0,0,1-.051.014",
    transform: "translate(4.149 -406.147)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_115",
    "data-name": "Tracciato 115",
    d: "M525.452,1118.794l.388-.018-.194-.27c-.711-1.642-.3-3.529-1.136-5.18a6.765,6.765,0,0,0-3-2.874c-1.1-.487-4.473-1.925-20.327-2.642-.079.112-.157.247-.228.334,6.539,7.808,11.293,11.925,14.177,12.168a10.449,10.449,0,0,0,3,.266,10.565,10.565,0,0,0,3.043-.61.493.493,0,0,0-.186.014c3.708-1.122,3.708-1.122,4.458-1.189",
    transform: "translate(-2.505 -403.228)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_116",
    "data-name": "Tracciato 116",
    d: "M372.3,1182.069c-4.834,8.673-9.86,14.013-12.7,15.93-2.688,1.8-2.688,1.8-9.382-.963,10.383.9,19.635-12.435,22.222-16.556l.491.407c-.172.345-.43.845-.631,1.182",
    transform: "translate(-57.565 -376.685)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_117",
    "data-name": "Tracciato 117",
    d: "M389.364,1174.537c1.143,5.712-15.818,15.385-17.331,14.3-1.095-.791-11.648-13.089-14.457-21.413-.979-2.845-2.287-6.748,4.434-8.129l1-.188a23.44,23.44,0,0,1,3.2-.146,1.762,1.762,0,0,0-.425.064c6.477,0,7.816.018,9.389-.687a.067.067,0,0,1-.014-.051l.061.06.035-.04-.018.074a5.231,5.231,0,0,1,.246.508c3.114,3.38,7.045,5.8,10.073,9.233,1.618,1.791,3.266,3.641,3.8,6.412",
    transform: "translate(-55.168 -384.791)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_118",
    "data-name": "Tracciato 118",
    d: "M363.29,1174.373c-4.066-6.247-9.37-10.276-19.559-14.878a56.488,56.488,0,0,1-9.139-4.807.07.07,0,0,0-.045-.036l-.046-.011a.027.027,0,0,0,.023.031l.194.5c-.221,1.266-.221,1.266-2.2,3.956a.723.723,0,0,1,.027-.248,4.093,4.093,0,0,0-.759,2.01l.07.725c1.429,10.253,40.783,31.1,41.154,31.252-.057-.922-7.518-15.11-9.725-18.492",
    transform: "translate(-64.294 -386.123)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_119",
    "data-name": "Tracciato 119",
    d: "M358.145,1184.266c3.439,3.653,6.561,7.592,10.223,11.016-.272-.036-33.82-15.754-36.821-23.279l-.168-.422a2.261,2.261,0,0,1,.011-1.085.54.54,0,0,1-.016.172c.461-2.126.523-2.414-.093-3.3l-.022-.034.029.005.041.036.579.349c5.2,2.643,10.8,4.482,15.745,7.6,3.3,2.079,5.117,3.255,10.492,8.944",
    transform: "translate(-64.488 -381.487)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_20",
    "data-name": "Raggruppa 20",
    transform: "translate(270.079 798.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_120",
    "data-name": "Tracciato 120",
    d: "M333.738,1176.37s-.019,0-.042-.037l-.014-.027c.014.027.037.06.056.064",
    transform: "translate(-333.682 -1176.306)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_121",
    "data-name": "Tracciato 121",
    d: "M355.968,1189.125c3.258,2.6,4.5,3.55,7.118,5.587a.886.886,0,0,1-.225,0c-10.818-4.867-24.4-11.469-27.6-15.274l-.192-.291a4.629,4.629,0,0,1-.4-.722.083.083,0,0,1,.057.09c-.4-1.451-.463-1.618-1-2.162l.393.186c4.34,2.026,8.843,3.677,13.041,6.055a90.276,90.276,0,0,1,8.811,6.531",
    transform: "translate(-333.667 -1176.289)",
    fill: "url(#linear-gradient-46)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_122",
    "data-name": "Tracciato 122",
    d: "M353.543,1191.03c-2.044-1.322-4.4-2.845-5.847-3.614-2.28-1.174-4.69-1.973-6.985-3.049a.215.215,0,0,0,.127.105,3.1,3.1,0,0,1,.766.922s-.042-.037-.085-.07a4.046,4.046,0,0,0,.836.792c.381.255.755.515,1.126.773.072.04.158.082.225.123a141.329,141.329,0,0,0,13.478,6.376c-1.223-.771-2.418-1.559-3.641-2.358m-12.832-6.662-.023-.005h0",
    transform: "translate(-61.044 -375.268)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_123",
    "data-name": "Tracciato 123",
    d: "M415.385,1186.879l-.392.19c-.845,1.108-.864,1.181-1.04,4a.7.7,0,0,0,.074-.212,3.129,3.129,0,0,1-.695,1.8l-.381.474c-7.073,5.686-45.782-5.811-46.1-5.951.09-.086,14.04-8.664,25.684-7.286,7.932,1.258,14.959,5.479,22.845,6.955l.046.011.067.015-.1.005",
    transform: "translate(-51.49 -376.955)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_124",
    "data-name": "Tracciato 124",
    d: "M406.545,1198.32a.1.1,0,0,1,.076-.01l-.046-.008-.053-.011-.621-.188c-4.021-1.625-7.774-3.828-11.863-5.266a42.085,42.085,0,0,0-10.01-2.541,174.216,174.216,0,0,0-21.353-.785c.239.152,32.892,12.865,39.988,10.956l.464-.15a2.992,2.992,0,0,0,.848-.524,1.2,1.2,0,0,0-.122.072c.9-.89,1.611-1.6,2.691-1.545",
    transform: "translate(-53.013 -373.405)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_125",
    "data-name": "Tracciato 125",
    d: "M393.179,1201.585l.273.036-.418-.166c-13.627-5.676-13.627-5.676-18.521-6.682-1.633-.3-5.012-.952-12.911-2.227.067.063.158.109.22.173,6.717,2.765,22.9,9.244,28.364,9.383l.3-.01a3.224,3.224,0,0,0,.788-.106.207.207,0,0,0-.132,0,4.989,4.989,0,0,1,2.034-.4",
    transform: "translate(-53.405 -372.278)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_126",
    "data-name": "Tracciato 126",
    d: "M376.5,1199.3l-.117-.026a2.773,2.773,0,0,0-.916.105l.1.022a2.85,2.85,0,0,1-.876-.038c-.44-.07-.863-.21-1.308-.283-3.307-.965-13-4.7-13.362-5.009,1.378.3,4.086.882,6.559,1.493,3.453.872,6.612,2.538,9.969,3.744l-.045-.008",
    transform: "translate(-53.984 -371.72)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_127",
    "data-name": "Tracciato 127",
    d: "M618.309,1186.174c-14.3,5.995-49.84,18.966-70.54,9.594,5.168,3.47,21.5,9.977,61.3-4.3-12.046,8.1-28.834,14.728-43.789,17.292,1.145-.515,2.621-1.231,3.778-1.765-40.8,9.661-46.3-19.358-41.441-28.758,2.725,3.421,2.725,3.421,26.835-2.862,10.8-2.807,22.731-2.759,27.735-1.808,5.3.994,5.3.994,19.615,10.661.276-1.409.612-3.312.894-4.743,3.89,7.067,9.368,9.237,16.308,6.408-.2.082-.477.2-.695.281",
    transform: "translate(6.692 -379.425)",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_128",
    "data-name": "Tracciato 128",
    d: "M788.669,1102.641c-9.177,15.455-25.977,39.585-53.952,66.515a43.153,43.153,0,0,0,5.2-5.886c-2.227-.13-2.227-.13-15.283,8.9-13.982,9.682-24.594,12.177-31.607,7.4-7.45-5.1-7.621-14.169-7.7-19.047-.173-10.688-.374-21.712-3.927-37.232-2.567,6.251-5.95,14.631-8.515,20.907,2.606-25.093-.456-54.625-29.716-52.82l-.075.011-.03.018-.053-.009a.021.021,0,0,1-.026.018c-.034.044-.059.04-.059.04a.075.075,0,0,1-.052.012c-.029,0-.034.02-.056.015a.06.06,0,0,0-.049.016c95.267-34.395,140.6-31.974,134.8,7.207,16.451-62.286-72.743-37.058-106.316-27.578,29.343-31.14,60.268-49.464,71.905-56.363,16.644-8.656,26.571-12.08,40.851-14.133-2.777,3.247-6.469,7.588-9.248,10.857,37.9-11.96,49.271,19.291,25.394,69.674-3.121,6.59-7.738,15.208-11.475,21.485",
    transform: "translate(49.289 -442.378)",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_129",
    "data-name": "Tracciato 129",
    d: "M458.942,1133.724h0c-.1-.045-.145-.157-.2-.221h0c.059.089.082.22.18.217h0l.025,0h0M529.392,868.4c.573-6.732-3.1-10.309-4.853-10.889a15.349,15.349,0,0,0-3.114-.722c-9.383-1.063-15.931,6.176-24.248,8.253-8.56,2.149-5.329-13.044-14.143-12.315-16.829,5.4-20.142,24.751-34.276,32.908-5.5,3.192-8.918-4.987-10.151-8.667-4.668-14.141-12.593-15.373-23.581-3.626-9.094,9.779-11.444,16.686-18.394,37.25-2.478,7.284-4.606,13.6-9.849,8.854-5.469-4.923-4.69-13.814-11.445-17.928-2.572-1.543-6.039-3.657-9.861,5.008-12.27,28.016-4.765,58.634,2.537,88.246,2.526,10.336-3.632,8.856-7.8,4.134-9.6-10.851-12.215-1.548-12.233-1.453-7.527,30.765,40.667,69.379,75.871,97.6-15.915-82.073-.235-133.369,59.884-196.1-109.564,128.04-28.5,230.251-25,234.55-7.113-14.311-13.61-44.916,22.412-89.313,7.92-9.726,13.161-16.162,10.43-21.71-6.367-13.04-29.787,5.311-29.364-9.2a15.373,15.373,0,0,1,.135-2.6c.694-3.442,6.892-7.317,25.325-18.872,31.331-19.6,34.014-24.869,34.915-26.6.307-.591,7.183-14.642-12.556-16.375-8.3-.728-13.284-1.17-15.344-7.688-2.433-7.613,5.734-11.9,14.373-16.432,9.475-4.963,19.262-10.111,22.2-18.765,3.282-9.691-13.754-6.51-15.807-14.925-2.912-12.167,13.12-12.729,13.936-22.624",
    transform: "translate(-58.669 -496.407)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_130",
    "data-name": "Tracciato 130",
    d: "M462.759,1173.974c-8.265-8.009-28.314-24.28-69.209-43.025a39.448,39.448,0,0,1,5.475-2.033c27.177,14.29,48.749,29.372,64.118,44.786-.121.078-.244.2-.384.272",
    transform: "translate(-41.736 -395.519)",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_131",
    "data-name": "Tracciato 131",
    d: "M585.732,1177.392c-3.424,3.309-6.8,4.653-13.106,6.811a18.612,18.612,0,0,0,4.209.072c-3.516,1.977-4.657,2.133-18.442,4.2a4.932,4.932,0,0,0,1.974.932c-1.576.517-1.576.517-14.251.49,1.347,1.023,3.125,2.4,4.473,3.443l-3.561-.261c6.8,4.832,6.8,4.832,7.106,5.28-1.472.136-3.444.269-4.941.375,5.813,2.719,5.813,2.719,6.571,4.152-1.859.86-5.522,1.915-12.3,1.769,4.4,4.318,2.737,7.826,1.554,10.383-1.223-.086-1.223-.086-2.826-1.193-.556,7.85-.556,7.85-1.52,9.006a15.037,15.037,0,0,0-1.973-1.282c-.285.165-.654.341-.915.481.1.583.1.583-1.412,5.264a.357.357,0,0,0-.183.012l-.09.085-.091-.049c-1.436.071-1.436.071-12.074-1.038a3.859,3.859,0,0,0,1.468,1.408c-5.267.025-8-.541-18.192-2.586.564.319,1.3.784,1.872,1.159l.206.576c-4.871-.393-11.512-.938-17.984-4.108-4.87,5.654-6.369,4.3-10.826.2-.191.539-.448,1.242-.664,1.779-1.947-.7-1.947-.7-8.3-5.006-.087.412-.2.968-.294,1.382l-4.377-3.3c-2.057,4.972-2.057,4.972-2.557,5.521-.224-.251-.543-.547-.76-.8-.388.019-.867.015-1.227.034-2.477,2.808-3.365,3.4-7.285,4.807.091-.334.229-.834.33-1.193-13.142.3-13.142.3-16.793-2.258-.942.251-.942.251-15.758-9.775-.232.148-.577.351-.815.53-3.6-1.485-4.007-4.2-3.668-6.235a6.55,6.55,0,0,0-1.917.429c-1.5-1.01-1.5-1.01-1.543-3.021-.434.135-1.006.315-1.44.452-2.574-3.443-2.5-3.678-.732-5.5-1.195-.689-1.195-.689-3.219-.115-.658-1.307-.658-1.307,2.96-5.611a6.028,6.028,0,0,0-2.018-.254c-.053-.371-.109-.812-.158-1.151.77-.9.77-.9,3.83-3.222.023-.325.044-.8.051-1.152-1.4-.937-1.4-.937-11.991-1.319.06-.3.121-.688.183-.976-1.943-.018-3.875.251-5.809.311-.4-4.132-.01-5.338.714-6.829-.73.453-1.7,1.077-2.448,1.5-1.378-2.4-1.64-4.223,1.087-7-.669.036-1.616.081-2.281.116,1.705-7.3,1.705-7.3.38-7.738.038-.319.085-.741.122-1.038,1.939-1.352,1.939-1.352,5.83-2.715-.228-.247-.513-.563-.741-.815,2.687-1.774,6.469-1.718,9.469-1.447.19-.263.43-.588.617-.856a20.291,20.291,0,0,0-1.518-1.743c2.508-.724,10.2.911,10.563.99-.365-.279-.844-.664-1.182-.963,2.031-.6,3.331-.422,9.822.8l.567.071.022,0,.027.008.02,0h0l.005-.022h0l.029,0c-.128-.254-.321-.627-.46-.908.082-.034,7.633-2.553,12.711,6.387,3.2,5.573,5.524,6.657,17.953,8.275-14.818,2.546-34.652,5.679-49.567,7.7,15.84-1.491,36.926-3.771,52.7-5.832-9.706,20.021-11.468,23.613-16.017,34.372,9.745-16.214,9.745-16.214,19.859-32.247,7.7,6.063,17.918,14.19,25.787,20.038,7.639,5.394,17.863,12.559,25.657,17.711-7.23-5.435-16.82-12.691-23.85-18.361-7.441-6.31-17.318-14.694-24.539-21.212,40.409.577,43.719.607,72.2-.657-39.632-.281-43.778-.318-72.32-2.176,11.348-8.508,26.374-19.989,37.506-28.771-11.7,8.048-27.424,18.625-39.34,26.379,3.09-7.789,1.839-9.348-5.282-13.164-4.677-2.5-5.2-2.743-5.959-4.5-.046-.036-.762-3.981,1.312-5.61a8.131,8.131,0,0,0,1.722,1.031c1.074-2.274,1.757-4.735,3.221-6.847.466.557,1.092,1.3,1.555,1.857a13.646,13.646,0,0,1,3.578-7.1c1.414.509,2.471,1.8,4.12,1.648a13.861,13.861,0,0,1,7.768-5.84c.085.3.176.672.268.972,3.726.322,6.572-2.43,10.07-2.812.307-.011.736-.018,1.046-.027.011.661.011.661,14.339,2.613a17.889,17.889,0,0,1-1.875,1.419c.012.052.038.057.038.057h0l.005-.022.018,0h0l.03.005h0l.019,0c3.637-.553,8.945-.874,13.364.812-1.154.535-2.683,1.192-3.832,1.7,2.186-.031,5.436-.093,13.6,1.241-1.406,1.7-1.466,1.757-4.632,3.857.591-.022,1.36-.083,1.939-.163-1.208,3-4.277,4.568-5.836,7.342.288.771.288.771,13.956-.2-.1.356-.258.855-.362,1.212,5.1,2.645,9.985-1.237,15.018-.4a27.384,27.384,0,0,0-3.94,2.086c4.128,2.206,8.8.127,12.995,1.693-.763.364-1.782.855-2.544,1.219a16.977,16.977,0,0,1,6.792.76,5.363,5.363,0,0,1-2.243,1.487c4.482,2.206,9.848,1.29,14.3,3.744a13.721,13.721,0,0,0-3.365.212c2.026,5.423,8.365,3.828,11.719,7.133a5.752,5.752,0,0,1-1.129,2.21,8.159,8.159,0,0,1,4.92,1.57,7.518,7.518,0,0,1-2.051,1.278c5.292,2.33,5.292,2.33,6.089,2.881a11.53,11.53,0,0,1-.9,1.681",
    transform: "translate(-41.728 -395.138)",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_132",
    "data-name": "Tracciato 132",
    d: "M685.638,1137.356c-.756.594-1.507,1.143-2.261,1.685l-1.4.887c1.151-.763,2.4-1.61,3.846-2.688-.061.041-.122.078-.186.116m18.412-12.953c.031-.019.031-.019.055-.015l-.049-.011c-38.017-30.878-62.792-22.309-73.325-18.636-37.858,18.167-47.44,46.03-32.367,59.657-29.928-2.362-44.757-10.646-52.819-29.443-2.2,2.516-3.024,3.451-4.369,5.208,11.326,23.5,44.036,32.556,85.422,23.571,1.281-.3,2.563-.631,3.842-.913.775-.21.862-.267.945-.278a1.169,1.169,0,0,0,.24-.075.5.5,0,0,0,.244-.067.883.883,0,0,0,.244-.078c.075-.01.188-.035.266-.046a.537.537,0,0,1,.218-.078,2.7,2.7,0,0,0,.265-.066,1.015,1.015,0,0,0,.243-.078c8.366-2.395,12.932-4.243,12.969-4.26a167.655,167.655,0,0,0,34.777-17.9c-18.341,12.538-44.05,27.331-80.419,30.057-13.51,22.965,3.294,31.606,26.8,24.965,34.246-9.686,64.814-52.733,76.359-70.788a4.515,4.515,0,0,1,.459-.732",
    transform: "translate(12.184 -405.421)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_133",
    "data-name": "Tracciato 133",
    d: "M500.558,1069.9c-4.235,1.185-9.03-.609-12.884,2.479-1.637,1.345-1.637,1.345-9.779,15.879-7.348,13.065-28.355,20.957-43.223,16.3,15.8-2.41,25.252-17.927,22.871-20.012-.967-.79-4.126,1.057-7.835,3.244-7.269,4.228-15.435,9.014-19.942,6.22,5.566-6.465,2.591-16.572,9.48-22.471,4.348-3.742,12.7-8.443,27.835-9.6,22.172-.531,32.942,6.656,33.6,7.632a2.224,2.224,0,0,1-.12.329",
    transform: "translate(-28.508 -419.994)",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_134",
    "data-name": "Tracciato 134",
    d: "M450.943,1110.349a36.292,36.292,0,0,1-6.493,21.144c-5.767-23.08-5.767-23.08-11.775-29.007-13.363-13.236-33.262-15.881-46.752-28.865,8.307,20.342,33.532,24.243,42.667,43.8-15.2-5.787-31.384-8.747-46.013-16.109-11.344-5.711-20.2-12.532-26.381-20.341-14.5-18.391-7.792-54.39-1.925-57.753a4.546,4.546,0,0,1,1.309-.35,2.725,2.725,0,0,1,1.765,1.191c4.512,5.378,8.758,10.465,19,16.322,12.252,7.02,25.68,11.741,37.46,19.623a153.789,153.789,0,0,1,16.945,13.173c5.454,4.994,19.946,18.271,20.195,37.173",
    transform: "translate(-58.558 -434.253)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_135",
    "data-name": "Tracciato 135",
    d: "M197.431,705.025c-9.9,12.791-14.4,18.651-17.217,21.156.049-.217.067-.441.112-.635l13.564-22.3c1.88-2.831,4.32-6.051,7.689-10.511-1.013,1.173-1.943,2.415-3.055,3.49l7.89-11.352,14.608-19.265a6.087,6.087,0,0,1,1.648-1.668,4.694,4.694,0,0,0,.564.1c1.043,2.452,1.043,2.452,9.671-2.974.038.057.105.124.138.182-.969,1.459-1.367,2.008-6.755,8.333-9.684,11.345-16.913,19.957-28.856,35.446",
    transform: "translate(-119.658 -566.403)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_136",
    "data-name": "Tracciato 136",
    d: "M466.222,1204.11c1.054,2.28,1.582,7.553-15.62,8.114h0c-3.081-1.093-5.836-4.726-1.111-7.047,1.652-.83,4.893-1.8,11.019-1.8a54.157,54.157,0,0,1,5.461.243c.071.143.18.341.251.486",
    transform: "translate(-22.232 -368.321)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_137",
    "data-name": "Tracciato 137",
    d: "M658.56,1158.7c-2.468,2.984-8.3,9.116-19.7,16.118-4.048-3.985,2.867-15.3,18.948-31.057,0-.025.031-.019.031-.019,4.841-.393,8.806,5.043.721,14.958",
    transform: "translate(47.45 -390.111)",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_138",
    "data-name": "Tracciato 138",
    d: "M422.417,1122.07c-7.486,2.1-34.082,6.814-62.417-20.178,7.29-6.095,20.082-5.356,24.286-5.132,25.375,2.365,36.2,16.465,40.372,24.652-.673.19-1.57.475-2.242.658",
    transform: "translate(-53.991 -407.319)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_139",
    "data-name": "Tracciato 139",
    d: "M444.016,809.095c-4.761,45.606-49.32,90.642-125.245,88.472,24.919-21.646,24.919-21.646,31.754-21.079.172.012,17.643,1.253,17.986,1.2a1.971,1.971,0,0,0,.112-3.924c-5.864-1.443-14.036-.98-20.041-1.416,15.744-12.443,15.744-12.443,22.368-12.074,6.078.325,12,2.437,18.184,1.571,2.472-.326,2.825-3.591-.557-3.991-9.549-1.126-14.4-1.389-19.045-1.659,2.161-2.542,15.37-12.141,15.453-12.149.37-.1,21.039,1.682,22.467,1.865,7.472,1.008,3.5-3.342,3.312-3.408-.419-.142-.419-.142-20.639-2.128.822-.759,20.67-15.452,20.811-15.546,8.936-6.221,9.1-6.413,9.371-6.81.8-1.12-.508-3.07-2.406-2.972-.607.018-.607.018-22.465,15.848.235-5.087.537-11.879.75-16.97a2.41,2.41,0,0,0-4.351-1.166c-3.079,5.813-1.018,15.265-1.427,21.832-14.888,11.082-14.888,11.082-15.991,11.956.22-5.113.5-11.934.74-17.018-.225-1.289-.5-1.652-2.037-2.059h0l-.023-.005-.02,0-.029-.005-.023-.006-.025-.005-.025-.005c-2.314.183-2.314.183-3.408,22.947-5.285,4.071-10.482,8.237-15.767,12.334.157-5.178.35-12.044.5-17.2-.217-1.337-.547-1.685-2.019-2.13l-.022,0c-2.4.112-2.4.112-3.267,23.1-13.19,10.69-31,26.024-32.986,27.721-3.879-52.583,47.851-99.055,108.543-97.467a148.394,148.394,0,0,1,19.944,1.824c-.049,3.155-.132,7.412-.472,10.526",
    transform: "translate(-70.136 -516.86)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_140",
    "data-name": "Tracciato 140",
    d: "M780.691,883.748c4.684,20.394,11.02,75.78-30.579,149.312,1.941-12.508.486-25.5,5.5-37.575,13.5-24.588,13.38-25.755,13.173-27.622-.233-.1-.575-.251-.852-.386-.942.834-.942.834-12.169,22.5,2.894-24.1,2.894-24.1,4.933-28.262,10.933-22.385,10.933-22.385,10.727-24.125-.281-.11-.65-.266-.931-.38-.156.145-.156.145-11.737,22.618,2.018-24.005,2.018-24.005,4.8-29.757,10.212-21.276,10.145-21.443,9.426-23.6-.309-.016-.72-.081-1.025-.071-5.867,6.529-7.275,15.18-10.948,22.813.018-.452,2.332-43.272,1.3-45.769-.329-.019-.724-.056-1.028-.045-.833.782-.833.782-2.7,34.994-2.7-2.609-6.325-6.1-9.071-8.716-.31-.015-.71-.026-1.025-.068-3.3,3.084-3.3,3.084,9.708,16.189-.4,7.983-1.076,15.909-1.555,23.877-2.625-2.613-6.146-6.131-8.759-8.772-.306-.014-.7-.051-.971-.083-3.5,3.091-3.5,3.091,9.183,15.825-.538,7.423-1.645,19-2.114,23.4-2.545-2.523-5.958-5.916-8.505-8.439-3.008-.12-2.915,4.481-2.81,4.706,2,4,7.405,7.417,10.572,10.581-3.438,29.85-3.648,31.652-6.152,47.709-21.164-14.612-30.8-82.606,14.04-188,4.25,4.105,14.22,13.695,19.559,37.14",
    transform: "translate(80.909 -498.633)",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_141",
    "data-name": "Tracciato 141",
    d: "M733.973,650.282c25.428,25.451,55.116,66.776,46.174,67.428-8.044.565-14.1-7.749-22.614-4.982-3.408,1.136-5.735,2.811-2.457,13.158-51.155-81.157-51.155-81.157-57.066-94.325-1.4-3.488-1.335-3.679-.609-5.951,4.983-1.657,12.392,3.409,25.235,14.025-8.221.7,7.965,35.776,20.852,62.115-27.386-60.362-18.521-58.853-15.164-56.94.153.109,4.314,4.146,5.649,5.472",
    transform: "translate(69.061 -579.465)",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_142",
    "data-name": "Tracciato 142",
    d: "M786.04,732.678c7.546,16.4,17.24,38.436,23.675,55.26a466.6,466.6,0,0,0-44.577-92.159c-.239-.407-.512-.795-.747-1.2,6.621,11.374,15.9,26.306,21.649,38.1",
    transform: "translate(93.714 -554.162)",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_143",
    "data-name": "Tracciato 143",
    d: "M816.637,850.638l2.291,31.569c.332,9.357.332,9.357-.845,17.629l.02.03L818,900.8l0,.13a.087.087,0,0,0-.021-.055l0,.023.033-.146L818,899.515c-.128-5.468-.295-8.463-.808-15.206.019.233.026.564.044.819-.182-2.567-.362-5.112-.572-7.662-4.511-58.792-4.511-58.792-5.5-63.963l5.476,37.135",
    transform: "translate(110.797 -510.724)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_144",
    "data-name": "Tracciato 144",
    d: "M802.828,779.053l-.33-1.059h0a84.564,84.564,0,0,1,2.862,15.244,203.449,203.449,0,0,0,3.522,22.826l.356,1.745c.362,1.6.7,3.214,1.039,4.8-.053-.213-.1-.5-.146-.715.75,3.453,2.146,9.852,2.666,13.885,0,.025,0,.025-.01.049l-.011.049.011-.049.068-.314a3.174,3.174,0,0,1,.343-.281c.543.143.865.668,1.337.948,1.408-1.24-2.989-27.9-11.707-57.13",
    transform: "translate(107.633 -523.694)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_145",
    "data-name": "Tracciato 145",
    d: "M794.325,754.2a1.264,1.264,0,0,1-.085-.171c.774,3.077.949,6.25,1.515,9.36a87.292,87.292,0,0,0,2.589,9.718l.306,1c.347,1.111.713,2.228,1.062,3.315-.023-.132-.09-.3-.116-.4.922,2.879,2.22,6.829,2.823,9.414.023.03.023.03.018.055h0l.038-.091c1.036.627.916,2.22,2.225,2.6.564-2.863-5.894-23.107-10.376-34.8",
    transform: "translate(104.616 -532.448)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_146",
    "data-name": "Tracciato 146",
    d: "M786.436,735.493c2.778,6.219,6.643,15.631,6.589,16.707-.552-.374-.668-1.107-1.136-1.537a.481.481,0,0,0,.022.131c-.015-.029-.037-.057-.033-.082l-.115-.279c-.587-1.518-1.222-3.02-1.862-4.5a.346.346,0,0,1,.072.142c-.453-1.084-.926-2.174-1.367-3.279-.33-.833-.632-1.656-.954-2.511-.16-.438-.314-.879-.492-1.345-.442-1.488-.792-3.006-1.2-4.511a2.755,2.755,0,0,0,.138.309c.1.222.235.531.34.755",
    transform: "translate(101.591 -539.606)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_147",
    "data-name": "Tracciato 147",
    d: "M823.024,987.955h0c-.03-.007-.018-.056-.018-.056,0-.1-.012-.179-.018-.255,0,.1.06.188.036.311h0M776.237,710.382c-2.63-4.111-3.182-4.484-4.827-5.546-.823,3.11-.03,6.242-.374,9.356-.441.057-1,.112-1.432.172-2.553-2.827-4.018-6.459-6.806-9.136-.369.074-.926.18-1.324.27-.666,11.774,7.562,21.6,7.154,33.324-.389.068-.919.157-1.308.224-5.185-4.838-5.611-16.214-15.511-14.555-.244.427-.522,1-.756,1.4-2.343,19.534,15.067,34.4,12.809,53.9-.452.105-1.031.207-1.506.281-5.92-4.008-6.266-14.1-15.622-14.379-2.017,9.712,16.225,54.489,24.161,73.306,9.448,22.331,9.448,22.331,7.078,24.629-2.661-1.384-4.119-4.127-6.542-5.79-.543.161-1.257.336-1.8.472-.949,1.718-3.906,6.975,10.3,36.56,9.181,19.213,23.205,35.475,33.211,54.206-11.368-112.394-28.935-203.2-29.106-203.945C799,807.6,807.015,867.777,822.988,987.644c-1.072-23.282,1.154-62.806,3.11-97.656,1.417-24.946-1.184-28.492-2.9-30.862-1.7.291-3.121,1.453-4.877,1.5-3.44-4.361-3.1-9.652-2.239-16.6,1.285-10.527,2.361-21.961,1.211-34.1-1-10.795-5.576-21.75-8.086-21.733-5.644.019-8.461-13.087-8.48-13.243a52.766,52.766,0,0,1-.829-9.164,51.114,51.114,0,0,0-4.055-18.712l-19.608-36.7",
    transform: "translate(87.208 -550.415)",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_21",
    "data-name": "Raggruppa 21",
    transform: "translate(857.486 466.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_148",
    "data-name": "Tracciato 148",
    d: "M820.024,974.877,815.39,990.6l.06-2.391-.542,3.907c-6.677,18.52-16.263,42.994-24.221,61.012l-7.416,14.644-.864,1.637.773-1.454c-5.552,9.682-12.7,22.761-18.667,32.2-.157.27-.408.594-.567.864.669-1.2,1.423-2.35,2.145-3.486-.612.856-1.227,1.685-1.9,2.475a1.555,1.555,0,0,1-.253-.13l.116-.179.037-.044.107-.128c2.838-4.851,5.843-9.618,8.623-14.533a22.107,22.107,0,0,0-1.734,2.533c4.141-7.456,8.374-14.891,12.373-22.4-.619,1-1.218,2.014-1.85,3.068,5.617-11.744,10.071-24.016,16.423-35.42-.223.1-.534.261-.782.36,1.825-3.883,3.849-7.647,5.666-11.505-.127.025-.265.071-.423.112l2.965-6.142c-.265-.033-.635-.086-.9-.119-.243-.862-.243-.862.684-11.745l.872.19c1.424-9.991,6.073-19.007,8.572-28.691,1.891-7.359,7.865-13,8.523-20.857l.111-.633a26.555,26.555,0,0,0,1.122-2.969c.231-.61.556-1.4.792-2.031.124.254.285.542.39.767l.008.332c.344-1.6.5-3.234.887-4.821a8.691,8.691,0,0,1-.126,2.909c.142-.527.324-1.245.414-1.782a18.658,18.658,0,0,1-.5,2.9l-6.28,25.818",
    transform: "translate(-763.938 -929.6)",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_149",
    "data-name": "Tracciato 149",
    d: "M811.975,936.651c.169-.9.341-1.824.489-2.729.014-.072.029-.145.037-.194l-.526,2.923",
    transform: "translate(-746.392 -933.728)",
    fill: "url(#linear-gradient-68)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_150",
    "data-name": "Tracciato 150",
    d: "M819.157,898.026c-.038.319-6.073,42.436-6.768,45.549-.44,2.033-4.544,19.87-8.383,21.951,4.393-9.8,7.562-28.225,7.735-33.374-.374.426-.374.426-1.529,5.211-4.105,16.674-5.409,17.785-5.846,18.17.012-.3,1.842-30.571,10.07-53.01,2.159-5.405,3.081-6.395,4.191-6.484a2.358,2.358,0,0,1,.528,1.987",
    transform: "translate(108.184 -480.578)",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_151",
    "data-name": "Tracciato 151",
    d: "M812.926,956.579a180.76,180.76,0,0,1-5.824,28.982c1.039-5.875,3.219-23.7.912-29.182-1.455-3.449-3.165-3.744-6.477-3.521-4.9.307-6.742-.191-10.058-4.374,1.175,6.834,4.01,11.52,8.433,13.89,3.689,2.011,4.56,4.553,4.643,13.655-5.893,1.282-10.365,6.516-16.876,6.1a13.148,13.148,0,0,1-11.274-7.9c-6.07-13.38-4.468-57.263-1.294-63.08.4-.193.571-.283,1.024.2,2.7,2.961,5.29,5.748,10.432,6.2,4.763.422,9.529-1.611,14.279-.055a14.92,14.92,0,0,1,6.182,4.042c3.958,4.776,8.243,13.063,5.9,35.05",
    transform: "translate(96.6 -475.116)",
    fill: "#889c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_152",
    "data-name": "Tracciato 152",
    d: "M665.713,593.428c15.264,10.176,26.549,18.963,35.583,26.228-3.227-2.646-6.351-5.166-11.741-9.266,9.45,7.685,22.133,17.836,31.244,25.948l16.64,15.866a15.311,15.311,0,0,1,2,2.227C725.669,641.414,700.08,617.191,666.4,593.9c-1.083-.74-2.158-1.479-3.276-2.176l2.594,1.7",
    transform: "translate(56.724 -591.728)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_153",
    "data-name": "Tracciato 153",
    d: "M792.31,1005.532c-3.611,11.9-11.308,29.416-22.075,43.06h0c1.8-7.179,11.968-31.628,20.057-41.926a22.19,22.19,0,0,1,2.441-2.638c-.117.456-.306,1.074-.423,1.5",
    transform: "translate(95.848 -441.134)",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_154",
    "data-name": "Tracciato 154",
    d: "M796.23,991.992c-5.574,10.336-16.04,25.436-23.7,10.5a85.888,85.888,0,0,1,14.028-21.059c8.985-9.143,11.019-3.67,11.153,2.509.078,5.151-.3,5.83-1.485,8.052",
    transform: "translate(96.689 -451.162)",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_155",
    "data-name": "Tracciato 155",
    d: "M731.676,702.243c27.9,30.665,25.665,47.44,19.673,92.324-10.527-21.829-9.013-47.818-23.409-68.335,3.49,8.7,5.573,14.967,5.4,28.875-.164,14.159-.374,31.772,23.179,65.9-11.418-8.056-27.462-25.185-38.323-49.186a199.108,199.108,0,0,1-9.237-25.653c-4.967-16.732-6.332-34.107-9.535-51.144-2.09-11.282-6.414-17.755-11.007-24.594-.669-1-.669-1.154-.662-1.635,3.957-.968,27.588,15.545,43.917,33.443",
    transform: "translate(65.723 -563.592)",
    fill: "#cecece"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImgBackgroundLogin);
export default __webpack_public_path__ + "static/media/SvgImgBackgroundLogin.092ebc030157663ca6ecff6d309ca438.svg";
export { ForwardRef as ReactComponent };